var map = {
	"./platform-logo-VeoliaApac.png": "71bd",
	"./platform-logo-adit.png": "e78b",
	"./platform-logo-default.png": "9f70",
	"./platform-logo-default1.png": "d7ce",
	"./platform-logo-mv.png": "d5b3",
	"./platform-logo-netafim.png": "ae33",
	"./platform-logo-salesforce.png": "d542",
	"./platform-logo-tecan.png": "fe08",
	"./platform-logo-transparent-default.png": "f952",
	"./platform-logo-vcheck.png": "a60f"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "a89f";